<template id="header">
	<div class="page-top">
		<div class="page-top-content">
			<div class="logo">
				<router-link to="/home">
					<img src="/web-static/img/logo.png">
				</router-link>
			</div>
			<ul class="menu">
				<li v-for="item in menuItems"><router-link v-bind:to="item.link">{{item.name}}</router-link></li>
			</ul>
			
		</div>
		<div class="page-top-bg"></div>
		<div class="page-top-bg-2"></div>
	</div>
	

	
</template>

<script>
export default {
	data() {
		return {
			menuItems: global.menuItems
		}
	}
}
</script>


// WEBPACK FOOTER //
// src/components/PageTop.vue